import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function KayakingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"kayaking"}/>
}
